module.exports = "/img/40.60c45a.webp";